import { useDispatch, useSelector } from "react-redux";
import { filterAppsForUser } from "../configs/AppsConfig";
import { toggleSider } from "../store/slices/appState.slice";
import { useNavigate } from "react-router-dom";
import {Avatar, Space, Row, Col, Layout, Typography} from "antd";
import Header from "./Header";
import Side from "./Side";
import { IAPlatformRoutes } from "../configs/AppRoutes";
import React from "react";
import useAccountInfo from "../hooks/useAccountInfo";
import Badges from "./Badges";


const {
    Content, Sider, Footer
} = Layout;


const AppFooter = ({showSider}) => (
  <Footer className="p-4 sticky bottom-0 bg-gray-50">
    <div className="flex justify-end items-center text-gray-400 text-sm">
      <div>© 2024 Intelligent Allocation™</div>
      <div className="flex gap-4">
        <span>Terms</span>
        <span>Privacy</span>
        <span>Support</span>
      </div>
    </div>
  </Footer>
);


const Frame = ({ keys }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showSider = useSelector((state) => state.appStates.siderVisible); // Get sider visible state from Redux
  const widgets = filterAppsForUser(keys);
  const {username, company} = useAccountInfo();
  const onToggleSider = () => {
    dispatch(toggleSider()); // Toggle collapse/expand
  };

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Layout className="site-layout" style={{ height: "calc(100vh - 64px)" }}> {/* Adjust height by header height (e.g., 64px) */}
          <Sider
              width={180}
              style={{
                  height: "100%",
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  background: "#1a1a1a"

              }}
              className={'border-r border-gray-200 shadow-slate-600/70 '}
              collapsible={true}
              collapsed={!showSider}
              onCollapse={onToggleSider}
          >
              <div style={{fontSize: '0.65rem', letterSpacing:'0.04em', color: "#fff", fontFamily: "SF Pro Display", fontWeight:'400'}}
                   className={'pl-3 pt-1 pb-2'}>
                  IA {showSider && <span>PLATFORM&trade;</span>} v1.5.3
              </div>
              <Row align={'middle'} justify={!showSider?'center':'start'} className={'pt-4 px-3'} gutter={8} wrap={false}>
                  <Col>
                      <Avatar size={32} style={{background: '#1d4ed8'}}
                              onClick={() => navigate('/settings')}>
                          {username && username.slice(0, 1).toUpperCase()}
                      </Avatar>
                  </Col>
                  {showSider && (
                      <Col>
                          <div className={'flex flex-col'}>
                              <div className={'text-xs text-gray-200 font-medium'}>
                                  {username}
                              </div>
                              <div className={'text-xs text-gray-300 line-clamp-1'} onClick={() => navigate('/company')}>
                                  {company?.company_name}
                              </div>
                          </div>
                      </Col>
                  )}

              </Row>
              <div className={'mt-4 pt-3'}

              >
                  <Side collapsed={!showSider}/>
              </div>
          </Sider>
          <Content
              style={{
                  margin: "0",
                  height: "100%",
                  overflow: "auto",
                  background: "transparent",
          }}
        >
            <div
                className="site-layout-background"
                style={{ height: "100%"}}
            >
                <IAPlatformRoutes widgets={widgets} />
            </div>
        </Content>
      </Layout>
        <AppFooter showSider={showSider} />

    </Layout>
  );
};

export default Frame;
